<template>
    <div class='VuePagination' :class='props.theme.wrapper'>
        <nav :class='props.theme.nav'>
            <p v-show="props.hasRecords" :class='props.theme.count' class="topPagination" v-html="props.count"></p>
        </nav>
    </div>

</template>

<script>
    export default {
        name: 'TopPagination',
        props: ['props']
    }
</script>

<style lang="scss" scoped>
    @import '../assets/global.scss';

    .topPagination {
        font-size: 0.875rem;
        color: $blue;
    }
</style>